import axios from 'axios';

import { Config } from '../../../shared/models/config';
import { useService } from '../../../shared/hooks/use-service';

export type EmbedInfo = {
  reportId: string;
  embedUrl: string;
  embedToken: string;
};

function createDashboardService(config: Config) {
  const BASE_PATH = '/dashboard';

  const getDashboard = async () => {
    // Promise MUSS zurückgegeben werden!
    return axios.get<EmbedInfo>(`${config.API_URL}${BASE_PATH}/fixed-report/embed-info`);
  };

  return {
    getDashboard,
  };
}

export const useDashboardService = () => useService(createDashboardService);
